import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-inconsistencia`

    return {
        index() {
            return repository.get(`${baseUrl}`);
        },
        getAreas(params) {
            return repository.get(`${baseUrl}/area?${urlUtil.serialize(params)}`)
        },
        getMicroareas(params) {
            return repository.get(`${baseUrl}/microarea?${urlUtil.serialize(params)}`)
        },
        list(params) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(params)}`)
        },
        getUnidades(params) {
            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(params)}`)
        },
        getInfraestruturas(params) {
            return repository.get(`${baseUrl}/infraestrutura?${urlUtil.serialize(params)}`)
        },
        getUsuarios(params) {
            return repository.get(`${baseUrl}/usuario?${urlUtil.serialize(params)}`)
        },
    }
}
